<template>
    <div>
        <div class="newRow">
            <div style="display:flex">
                <h4>Draft Contract</h4>
            </div>

            <div class="row" style="margin: 0px;">
                <span class="col-sm-6 "
                    style="line-height: 32px;text-align: left;padding-left: 0px;color: #754f34;font-size: 12px;">Company
                    Entity Name</span>
                <span class="col-sm-2 "
                    style="line-height: 32px;text-align: left;color: #754f34;font-size: 12px;">Contract
                    No.(Draft)</span>
                <span class="col-sm-2 "
                    style="line-height: 32px;text-align: left;color: #754f34;font-size: 12px;">Sub-Group Code</span>
                <span class="col-sm-2 " style="line-height: 32px;text-align: left;color: #754f34;font-size: 12px;">Date
                    of Issue <span style="color: #b60005;">*</span></span>
            </div>
            <div class="row" style="margin: 0px;">
                <div class="col-sm-6 " style=" padding-left: 0px;padding-right: 0px;">
                    <div style="display: flex; column-gap: 10px;">
                        <base-input style="flex-grow: 1;" value="GP">

                        </base-input>
                        <base-input style="flex-grow: 23;" value="Asiaray Bus Media Limited">

                        </base-input>
                    </div>
                </div>
                <div class="col-sm-2 " style=" padding-right: 0px;">
                    <base-input value="T0000000001">

                    </base-input>
                </div>
                <div class="col-sm-2 " style=" padding-right: 0px;">
                    <base-input value="Bss">

                    </base-input>
                </div>
                <div class="col-sm-2 " style=" padding-right: 0px;">
                    <base-input>
                        <el-date-picker type="date" style="border:0px;">
                        </el-date-picker>
                    </base-input>
                </div>
            </div>

            <div class="row" style="margin: 0px;">
                <span class="col-sm-6 "
                    style="line-height: 32px;text-align: left;padding-left: 0px;color: #754f34;font-size: 12px;">Company
                    Address</span>
                <span class="col-sm-2 "
                    style="line-height: 32px;text-align: left;color: #754f34;font-size: 12px;">Tel</span>
                <span class="col-sm-2 "
                    style="line-height: 32px;text-align: left;color: #754f34;font-size: 12px;">Fax</span>
                <span class="col-sm-2 " style="line-height: 32px;text-align: left;color: #754f34;font-size: 12px;">Sign
                    Back Before <span style="color: #b60005;">*</span></span>
            </div>
            <div class="row" style="margin: 0px;">
                <div class="col-sm-6 " style=" padding-left: 0px;padding-right: 0px;">

                    <base-input value="Asiaray Bus Media Limited">

                    </base-input>

                </div>
                <div class="col-sm-2 " style=" padding-right: 0px;">
                    <div style="display: flex; column-gap: 10px;">
                        <base-input value="852" style="flex-grow: 2;">

                        </base-input>

                        <base-input value="-" style="flex-grow: 8;">

                        </base-input>
                    </div>
                </div>
                <div class="col-sm-2 " style=" padding-right: 0px;">
                    <base-input value="Bss">

                    </base-input>
                </div>
                <div class="col-sm-2 " style=" padding-right: 0px;">
                    <base-input>
                        <el-date-picker type="date" style="border:0px;">
                        </el-date-picker>
                    </base-input>
                </div>
            </div>

            <div class="row" style="margin: 0px;">
                <span class="col-sm-12 "
                    style="line-height: 32px;text-align: left;padding-left: 0px;color: #754f34;font-size: 12px;">Contracting
                    Party</span>
            </div>
            <div class="row" style="margin: 0px;">
                <div class="col-sm-12 " style=" padding-left: 0px;padding-right: 0px;">
                    <base-input value="Asiaray Bus Media Limited">
                    </base-input>
                </div>
            </div>

            <div class="row" style="margin: 0px;">
                <span class="col-sm-12 "
                    style="line-height: 32px;text-align: left;padding-left: 0px;color: #754f34;font-size: 12px;">Address</span>
            </div>
            <div class="row" style="margin: 0px;">
                <div class="col-sm-12 " style=" padding-left: 0px;padding-right: 0px;">
                    <base-input value="Asiaray Bus Media Limited">
                    </base-input>
                </div>
            </div>

            <div class="row" style="margin: 0px;">
                <span class="col-sm-12 "
                    style="line-height: 32px;text-align: left;padding-left: 0px;color: #754f34;font-size: 12px;">Contact
                    Person</span>
            </div>
            <div class="row" style="margin: 0px;">
                <div class="col-sm-12 " style=" padding-left: 0px;padding-right: 0px;">
                    <base-input value="Asiaray Bus Media Limited">
                    </base-input>
                </div>
            </div>
            <div class="row" style="margin: 0px;">
                <span class="col-sm-12 "
                    style="line-height: 32px;text-align: left;padding-left: 0px;color: #754f34;font-size: 12px;">Email</span>
            </div>
            <div class="row" style="margin: 0px;">
                <div class="col-sm-12 " style=" padding-left: 0px;padding-right: 0px;">
                    <base-input value="Asiaray Bus Media Limited">
                    </base-input>
                </div>
            </div>

            <div class="row" style="margin: 0px;">
                <span class="col-sm-6 "
                    style="line-height: 32px;text-align: left;padding-left: 0px;color: #754f34;font-size: 12px;">Contact
                    No. Tel</span>
                <span class="col-sm-6 "
                    style="line-height: 32px;text-align: left;padding-left: 0px;color: #754f34;font-size: 12px;">Contact
                    No. Fax</span>
            </div>
            <div class="row" style="margin: 0px;">
                <div class="col-sm-6 " style=" padding-left: 0px;">
                    <base-input value="23568632">
                    </base-input>
                </div>
                <div class="col-sm-6 " style=" padding-left: 0px;padding-right: 0px;">
                    <base-input value="xxx">
                    </base-input>
                </div>
            </div>

            <div class="row" style="margin: 0px;">
                <span class="col-sm-12 "
                    style="line-height: 32px;text-align: left;padding-left: 0px;color: #754f34;font-size: 12px;">Advertiser</span>
            </div>
            <div class="row" style="margin: 0px;">
                <div class="col-sm-12 " style=" padding-left: 0px;padding-right: 0px;">
                    <base-input value="Asiaray Bus Media Limited">
                    </base-input>
                </div>
            </div>

            <div class="row" style="margin: 0px;">
                <span class="col-sm-12 "
                    style="line-height: 32px;text-align: left;padding-left: 0px;color: #754f34;font-size: 12px;">Product
                    / Campaign</span>
            </div>
            <div class="row" style="margin: 0px;">
                <div class="col-sm-12 " style=" padding-left: 0px;padding-right: 0px;">
                    <base-input value="Asiaray Bus Media Limited">
                    </base-input>
                </div>
            </div>

            <div class="row" style="margin: 0px;">
                <span class="col-sm-12 "
                    style="line-height: 32px;text-align: left;padding-left: 0px;color: #754f34;font-size: 12px;">Media
                    Item</span>
            </div>
            <div class=" newCard" style="padding: 0px; margin: 0px; padding-top: 5px;">
                <el-table>
                    <!-- <el-table-column type="No." label="No."  width="50"/> -->

                    <el-table-column width="15">
                        <template slot-scope="scope">

                        </template>
                    </el-table-column>
                    <el-table-column label="Media Format" width="200">

                    </el-table-column>
                    <el-table-column label="Location" min-width="200" />
                    <el-table-column label="Gross Rate (W) / CPM" min-width="170" />
                    <el-table-column label="Qty / IMP" min-width="170" />
                    <el-table-column label="Production Cost Type" min-width="130" />
                    <el-table-column label="Period" min-width="170">
                    </el-table-column>
                    <el-table-column label="Commencement Date" min-width="150" />
                    <el-table-column label="Duration" min-width="150">

                    </el-table-column>


                </el-table>
            </div>

            <div class="row" style="margin: 0px;">
                <span class="col-sm-12 "
                    style="line-height: 32px;text-align: left;padding-left: 0px;color: #754f34;font-size: 12px;">Media
                    Bonus Item</span>
            </div>
            <div class=" newCard" style="padding: 0px; margin: 0px; padding-top: 5px;">
                <el-table>
                    <!-- <el-table-column type="No." label="No."  width="50"/> -->

                    <el-table-column width="15">
                        <template slot-scope="scope">

                        </template>
                    </el-table-column>
                    <el-table-column label="Media Format" width="200">

                    </el-table-column>
                    <el-table-column label="Location" min-width="200" />
                    <el-table-column label="Gross Rate (W) / CPM" min-width="170" />
                    <el-table-column label="Qty / IMP" min-width="170" />
                    <el-table-column label="Production Cost Type" min-width="130" />
                    <el-table-column label="Period" min-width="170">
                    </el-table-column>
                    <el-table-column label="Commencement Date" min-width="150" />
                    <el-table-column label="Duration" min-width="150">

                    </el-table-column>


                </el-table>
            </div>


            <div class="row" style="margin: 0px;">
                <span class="col-sm-6 "
                    style="line-height: 32px;text-align: left;padding-left: 0px;color: #754f34;font-size: 12px;">Grand
                    Total</span>
            </div>
            <div class="row" style="margin: 0px;">
                <div class="col-sm-6 " style=" padding-left: 0px;">
                    <base-input value="$855,038.00">
                    </base-input>
                </div>
            </div>

            <div class="row" style="margin: 0px;">
                <span class="col-sm-6 "
                    style="line-height: 32px;text-align: left;padding-left: 0px;color: #754f34;font-size: 12px;">Production
                    Cost</span>
            </div>
            <div class="row" style="margin: 0px;">
                <div class="col-sm-6 " style=" padding-left: 0px;">
                    <base-input value="$855,038.00">
                    </base-input>
                </div>
                <div class="col-sm-6 " style=" padding-left: 0px;">
                    <base-checkbox style="color: #9a9a9a;">Show in Contract</base-checkbox>
                </div>
            </div>

            <div class="row" style="margin: 0px;">
                <span class="col-sm-6 "
                    style="line-height: 32px;text-align: left;padding-left: 0px;color: #754f34;font-size: 12px;">Nett
                    Grand Total</span>
            </div>
            <div class="row" style="margin: 0px;">
                <div class="col-sm-6 " style=" padding-left: 0px;">
                    <base-input value="$855,038.00">
                    </base-input>
                </div>
            </div>

            <div class="row" style="margin: 0px;">
                <span class="col-sm-6 "
                    style="line-height: 32px;text-align: left;padding-left: 0px;color: #754f34;font-size: 12px;">Payment
                    Terms</span>
            </div>
            <div class="row"
                style="margin: 0px;padding-bottom: 5px;margin-bottom:5px; border-bottom: solid 1px #e3e3e3;">
                <div class="col-sm-6 " style=" padding-left: 0px;">
                    <base-checkbox style="color: #9a9a9a;">Show Total Amount Only</base-checkbox>
                </div>
            </div>
            <div class=" newCard" style="padding: 0px; margin: 0px; padding-top: 5px;">
                <el-table>
                    <!-- <el-table-column type="No." label="No."  width="50"/> -->

                    <el-table-column width="15">
                        <template slot-scope="scope">

                        </template>
                    </el-table-column>
                    <el-table-column label="PS NO." width="200">

                    </el-table-column>
                    <el-table-column label="Description" min-width="200" />
                    <el-table-column label="Contract No." min-width="170" />
                    <el-table-column label="From" min-width="170" />
                    <el-table-column label="To" min-width="130" />
                    <el-table-column label="No. Of Schedule" min-width="170">
                    </el-table-column>
                    <el-table-column label="Installment(Media)" min-width="150" />
                    <el-table-column label="Installment(Product)" min-width="150">

                    </el-table-column>
                    <el-table-column label="Total Amount" min-width="150">

                    </el-table-column>

                </el-table>
            </div>

            <div class="row" style="margin: 0px;">
                <span class="col-sm-6 "
                    style="line-height: 32px;text-align: left;padding-left: 0px;color: #754f34;font-size: 12px;">Bank
                    Details</span>
            </div>
            <div class=" newCard" style="padding: 0px; margin: 0px; padding-top: 5px;">
                <el-table>
                    <!-- <el-table-column type="No." label="No."  width="50"/> -->

                    <el-table-column width="15">
                        <template slot-scope="scope">

                        </template>
                    </el-table-column>
                    <el-table-column label="Bank Name" min-width="300">

                    </el-table-column>
                    <el-table-column label="Account Name" min-width="300" />
                    <el-table-column label="Account Number" min-width="300" />
                </el-table>
            </div>

            <div class="row" style="margin: 0px;">
                <span class="col-sm-6 "
                    style="line-height: 32px;text-align: left;padding-left: 0px;color: #754f34;font-size: 12px;">Internal
                    Remark</span>
            </div>
            <div class="row" style="margin: 0px;">
                <div class="col-sm-12 " style=" padding-left: 0px;padding-right:0px;">
                    <base-input>
                        <el-input type="textarea" value="xxxxxxx" style="border: solid 1px #543d2c;border-radius: 5px;">
                        </el-input>
                    </base-input>
                </div>
            </div>


            <div class="row" style="margin: 0px;">
                <span class="col-sm-6 "
                    style="line-height: 32px;text-align: left;padding-left: 0px;color: #754f34;font-size: 12px;">Client
                    Sign Box</span>
            </div>
            <div class="row"
                style="margin: 0px;padding-bottom: 5px;margin-bottom:5px; border-bottom: solid 1px #e3e3e3;">
                <div class="col-sm-6 " style=" padding-left: 0px;">
                    <base-checkbox style="color: #9a9a9a;">Is required</base-checkbox>
                </div>
            </div>

            <div class="row" style="margin: 0px;">
                <span class="col-sm-6 "
                    style="line-height: 32px;text-align: left;padding-left: 0px;color: #754f34;font-size: 12px;">Signed
                    Contract</span>
            </div>
            <div class="row"
                style=" margin: 0px;padding-bottom: 5px;margin-bottom:5px; border-bottom: solid 1px #e3e3e3;">
                <div class="col-sm-4 newCard " style=" padding-left: 0px;margin-right:10px; text-align: center;">

                    <image-upload @change="onImageChange" select-text="Select Image" />
                </div>

                <div class="col-sm-6 newCard " style=" padding-left: 0px;text-align: center;position: relative;">
                    <div class="row" style="padding-top:65px; padding-bottom: 15px;">
                        <div class="col-sm-2">
                            <i class="el-icon-paperclip" />
                        </div>
                        <div class="col-sm-3">
                            <img height="25"
                                src="https://iconarchive.com/download/i7909/hopstarter/soft-scraps/Adobe-PDF-Document.ico" />
                            file name.pdf
                        </div>
                        <div class="col-sm-4">
                            <el-progress :percentage="70"></el-progress>
                        </div>
                        <div class="col-sm-2">276MB</div> X
                    </div>
                    <div class="row" style="padding-top:15px; padding-bottom: 15px;">
                        <div class="col-sm-2">
                            <i class="el-icon-paperclip" />
                        </div>
                        <div class="col-sm-3">
                            <img height="25"
                                src="https://iconarchive.com/download/i7909/hopstarter/soft-scraps/Adobe-PDF-Document.ico" />
                            file name.pdf
                        </div>
                        <div class="col-sm-4">
                            <el-progress :percentage="70"></el-progress>
                        </div>
                        <div class="col-sm-2">276MB</div> X
                    </div>
                    <div class="row" style="position: absolute;width: 100%; bottom: 10px;text-align: center;">
                        <div class="col-sm-12">
                            <base-button>Save</base-button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row" style="margin: 0px;">
                <span class="col-sm-4 "
                    style="line-height: 32px;text-align: left;padding-left: 0px;color: #754f34;font-size: 12px;">Sign
                    by</span>
                <span class="col-sm-4 "
                    style="line-height: 32px;text-align: left;padding-left: 0px;color: #754f34;font-size: 12px;">Title</span>
                <span class="col-sm-4 "
                    style="line-height: 32px;text-align: left;padding-left: 0px;color: #754f34;font-size: 12px;">Salesperson</span>
            </div>
            <div class="row" style="margin: 0px;">
                <div class="col-sm-4 " style=" padding-left: 0px;">
                    <base-input value="Fax">
                    </base-input>
                </div>
                <div class="col-sm-4 " style=" padding-left: 0px;">
                    <base-input value="Fax">
                    </base-input>
                </div>
                <div class="col-sm-4 " style=" padding-left: 0px;padding-right: 0px;">
                    <base-input value="Fax">
                    </base-input>
                </div>
            </div>

            <div class="row" style="margin: 0px;">
                <span class="col-sm-4 "
                    style="line-height: 32px;text-align: left;padding-left: 0px;color: #754f34;font-size: 12px;">Account
                    Contact</span>
                <span class="col-sm-4 "
                    style="line-height: 32px;text-align: left;padding-left: 0px;color: #754f34;font-size: 12px;">Title</span>
                <span class="col-sm-4 "
                    style="line-height: 32px;text-align: left;padding-left: 0px;color: #754f34;font-size: 12px;">Contact
                    Number</span>
            </div>
            <div class="row" style="margin: 0px;">
                <div class="col-sm-4 " style=" padding-left: 0px;">
                    <base-input value="Fax">
                    </base-input>
                </div>
                <div class="col-sm-4 " style=" padding-left: 0px;">
                    <base-input value="Fax">
                    </base-input>
                </div>
                <div class="col-sm-4 " style=" padding-left: 0px;padding-right: 0px;">
                    <base-input value="Fax">
                    </base-input>
                </div>
            </div>

            <div style="width:100%; display:flex; justify-content: flex-end ;margin: 0px;">
                <base-button type="primary">Edit</base-button>
            </div>
        </div>
    </div>
</template>
<script setup>
    import baseInput from "@/components/newUI/Inputs/BaseInput";
    import baseButton from "@/components/newUI/BaseButton";
    import baseRadio from "@/components/newUI/Inputs/BaseRadio";
    import { nextTick, ref } from 'vue';
    var newPaymentScheduleDialogShow = ref(false);
    
</script>